import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {

  passwordShow: any = 'password';
  showpwd: boolean = false;
  showPassword: boolean = false;
  token: any;
  loginForm: FormGroup = new FormGroup({});
  error: any;
  cfmpwdAndpwd: boolean = false;
  formSubmitted: boolean = false;
  constructor(public router: Router, private route: ActivatedRoute, private fb: FormBuilder, private config: Config, private http: HttpService,
    public dialog: MatDialog, private loader: LoaderService) {
    this.route.queryParams.subscribe((res) => {
      this.token = res['token'];
      if (this.token) {

      }
    });
  }

  ngOnInit() {
    this.initializeForm();
  }
  onEyeClick() {
    this.showPassword = !this.showPassword;
    if (this.showPassword) {
      this.passwordShow = "text";
      this.showpwd = true;
    } else {
      this.passwordShow = "password";
      this.showpwd = false;
    }
  }
  password: string = '';
  validations = {
    minLength: false,
    capitalLetter: false,
    smallLetter: false,
    numericCharacter: false,
    specialCharacter: false
  };

  validatePassword() {
    this.validations.minLength = this.loginForm.value.password.length >= 8;
    this.validations.capitalLetter = /[A-Z]/.test(this.loginForm.value.password);
    this.validations.smallLetter = /[a-z]/.test(this.loginForm.value.password);
    this.validations.numericCharacter = /\d/.test(this.loginForm.value.password);
    this.validations.specialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(this.loginForm.value.password);
  }
  initializeForm() {
    this.loginForm = this.fb.group({
      confirmPassword: ['',
        [Validators.required,
        Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).*$")]
      ],
      password: ['',
        [Validators.required,
        Validators.pattern("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+_=)/()/-]).*$")]
      ]
    });
  }
  onClickLogin() {
    this.formSubmitted = true;
    this.loginForm.markAllAsTouched();
    this.error = "";
    var flag = true;
    if (this.loginForm.value.confirmPassword != this.loginForm.value.password) {
      flag = false;
      this.cfmpwdAndpwd = true;
    } else {
      this.cfmpwdAndpwd = false;
    }
    if (!this.validations.minLength ||
      !this.validations.capitalLetter ||
      !this.validations.smallLetter ||
      !this.validations.numericCharacter ||
      !this.validations.specialCharacter) {
      flag = false;
      return;
    }
    if (this.loginForm.invalid) {
      flag = false;
      return;
    }
    if (flag == true) {
      this.formSubmitted = false;
      const request = {
        "password": this.loginForm.value.password,
        "token": this.token
      };
      this.loader.simpleLoaderWithDuration();
      this.http.callPostServiceForLogin(this.config.resetPassword, request)
        .subscribe((data: any) => {
          this.loader.dismissLoader();
          if (data?.success) {
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: 'Password set successfully.',
                btn2: 'OK',
                btn2BgColor: '#F6921E',
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['/login']);
            });
          } else {
            window.alert(data?.message)
          }
        });
      this.loader.dismissLoader();
    }
  }
  backToLogin() {
    this.router.navigate(['/login']);
  }
}